module.exports = __webpack_public_path__ + "static/media/undraw_online_groceries_a02y.80fbd888.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Landing/undraw_online_groceries_a02y.svg
// module id = 2856
// module chunks = 0